import { eventHub } from '@/main'

const state = {
    isShowingUpgradePlanPopup: false,
    isShowingSomethingWentWrongPopup: false,
    showRichPrompt: false,
    richPromptServerInfo: null,
    richPromptStatuses: [
        {
            id: 0,
            label: 'success'
        },
        {
            id: 1,
            label: 'info'
        },
        {
            id: 2,
            label: 'error'
        },
    ]
}

const getters = {
    getIsShowingUpgradePlanPopup: (state) => state.isShowingUpgradePlanPopup,
    getIsShowingSomethingWentWrongPopup: (state) => state.isShowingSomethingWentWrongPopup,
    getShowRichPrompt: (state) => state.showRichPrompt,
    getRichPromptServerInfo: (state) => state.richPromptServerInfo,
    getRichPromptStatuses: (state) => state.richPromptStatuses,
}

const actions = {
    showUpgradePlanPopup: ({ commit }, payload) => {
        commit('TOGGLE_UPGRADE_PLAN_POPUP', payload)
    },

    showSomethingWentWrongPopup: ({ commit }, payload) => {
        commit('TOGGLE_SOMETHING_WENT_WRONG_POPUP', payload)
    },

    // RichPrompt
    displayRichPrompt: ({state}) => {
        state.showRichPrompt = true
    },

    hideRichPrompt: ({state}) => {
        state.showRichPrompt = false
    },

    richPrompt: function ({state, dispatch}, serverInfo) {
        state.richPromptServerInfo = serverInfo
        dispatch('displayRichPrompt')

        var promise = new Promise(function(resolve, reject) {
            eventHub.$on('responeRichPrompt', (responseType) => {
                switch (responseType) {
                    case "default_ok":
                        resolve(responseType);
                        dispatch('hideRichPrompt')
                        break;
                    case "default_cancel":
                        reject(responseType);
                        dispatch('hideRichPrompt')
                        break;
                    default:

                }
            });
        });

        return promise
    }
}

const mutations = {
    TOGGLE_UPGRADE_PLAN_POPUP: (state, payload) => {
        state.isShowingUpgradePlanPopup = payload;
    },
    TOGGLE_SOMETHING_WENT_WRONG_POPUP: (state, payload) => {
        state.isShowingSomethingWentWrongPopup = payload;
    },
}

export default {
    state,
    getters,
    actions,
    mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/app.js